'use client';
import { ThemeContext } from './provider';
import { useContext } from 'react';
import selectTheme from '@banzai/themes/select-theme';

export function useTheme() {
  const configContext = useContext(ThemeContext);
  const actualTheme = selectTheme(configContext.themeId);
  return { theme: actualTheme, darkMode: configContext.darkMode };
}
